// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#menuBar[data-v-776e4e54] {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  background: #fff;\n  display: flex;\n  justify-content: space-around;\n  padding: 0.58667rem 0;\n  width: 100%;\n  z-index: 99;\n}\n#menuBar img[data-v-776e4e54] {\n  width: 0.61333rem;\n  height: 0.61333rem;\n}\n", ""]);
// Exports
module.exports = exports;
